export default {
  api_endpoint: process.env.REACT_APP_API_URL,
  distributors: (process.env.REACT_APP_DISTRIBUTORS || '').toUpperCase(),
  status_refresh_timeout: (process.env.REACT_APP_STATUS_REFRESH_TIMEOUT || 5),
};
